import React from 'react';
import { FormattedMessage } from 'react-intl';
import style from './acmiEnquiryDetails.module.scss';
import { Booking } from 'acscp/store';
import { DateStyle, FormattedDate } from 'acscp/components/common/formattedDate';
import classNames from 'classnames';

const AcmiEnquiryDetails: React.SFC<{bookingDetails: Booking}> = ({bookingDetails}) => {
    const bookingFirstLeg = bookingDetails.legs[0];
    return (
        <div className={classNames(style.acmiEnquiryDetailsGrid, style.defaultTextColour, style.fontSize)}>
            <div className={style.base}>
                <div className={style.bold}>
                    <FormattedMessage
                        id={'components.acmiEnquiryDetails.acmiEnquiryDetails.baseLocation'}
                        defaultMessage={'BASE LOCATION'}
                    />:
                </div>
                <div>{bookingFirstLeg.departureLocation}</div>
            </div>
            <div className={style.startDate}>
                <div className={style.bold}>
                    <FormattedMessage
                        id={'components.acmiEnquiryDetails.acmiEnquiryDetails.startDate'}
                        defaultMessage={'START DATE'}
                    />:
                </div>
                <div>
                    <FormattedDate date={bookingFirstLeg.departureDate} style={DateStyle.Long}/>
                </div>
            </div>
            {bookingFirstLeg.arrivalDate &&
                <div className={style.endDate}>
                    <div className={style.bold}>
                        <FormattedMessage
                            id={'components.acmiEnquiryDetails.acmiEnquiryDetails.endDate'}
                            defaultMessage={'END DATE'}
                        />:
                    </div>
                    <div>
                        <FormattedDate date={bookingFirstLeg.arrivalDate} style={DateStyle.Long}/>
                    </div>
                </div>
            }
            <div className={style.acmiFields}>
                {bookingDetails.period !== null &&
                    <div>
                        <div className={style.bold}>
                            <FormattedMessage
                                id={'components.acmiEnquiryDetails.acmiEnquiryDetails.period'}
                                defaultMessage={'PERIOD'}
                            />:
                        </div>
                        <div>{bookingDetails.period} month(s)</div>
                    </div>
                }
                {bookingDetails.minGuaranteedBlockHours &&
                    <div>
                        <div className={style.bold}>
                            <FormattedMessage
                                id={'components.acmiEnquiryDetails.acmiEnquiryDetails.blockHours'}
                                defaultMessage={'BLOCK HOURS'}
                            />:
                        </div>
                        <div>{bookingDetails.minGuaranteedBlockHours}</div>
                    </div>
                }
                {bookingDetails.routeNetwork &&
                    <div>
                        <div className={style.bold}>
                            <FormattedMessage
                                id={'components.acmiEnquiryDetails.acmiEnquiryDetails.routeNetwork'}
                                defaultMessage={'ROUTE NETWORK'}
                            />:
                        </div>
                        <div>{bookingDetails.routeNetwork}</div>
                    </div>
                }
                {bookingDetails.cycleRatio &&
                    <div>
                        <div className={style.bold}>
                            <FormattedMessage
                                id={'components.acmiEnquiryDetails.acmiEnquiryDetails.cycleRatio'}
                                defaultMessage={'CYCLE RATIO'}
                            />:
                        </div>
                        <div>{bookingDetails.cycleRatio}</div>
                    </div>
                }
            </div>
        </div>
    );
};

export { AcmiEnquiryDetails };
